import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Contact.css";
import {
  FaEnvelope,
  FaPhone,
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaMapMarkerAlt,
} from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { db } from "./Firebase";
import { ref, push, set } from "firebase/database";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Contact() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      toast.error("Please fill in all fields.", { position: "top-center" });
      return;
    }

    try {
      const messageRef = push(ref(db, "messages"));
      await set(messageRef, { ...formData, timestamp: new Date().toISOString() });

      await emailjs.send(
        "service_fig086g",
        "template_ingitze",
        {
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message,
        },
        "bFQYhEIi7v6cFJdzk"
      );

      toast.success("Message sent successfully!", { position: "top-center" });
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      console.error(err);
      toast.error("Failed to send message. Please try again.", { position: "top-center" });
    }
  };

  // ✅ Navigate to Navigation.jsx page
  const goToNavigation = () => {
    navigate("/navigation");
  };

  return (
    <div className="contact-page-wrapper">
      <header className="header-top">
        <div className="header-left">
          <img src="/logo.jpg" alt="Zhufu Logo" className="header-logo" />
        </div>

        <div className="header-right">
          <nav className="nav-links">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/services">Services</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/contact">Contact</Link>
          </nav>
          <button className="menu-btn" onClick={goToNavigation}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
        </div>
      </header>

      <div className="contact-container">
        <h1 className="contact-heading">Get in Touch with Us</h1>
        <div className="contact-content">
          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>
              <FaEnvelope />{" "}
              <a href="mailto:Zhufuagency1@gmail.com" className="contact-link">
                Zhufuagency1@gmail.com
              </a>
            </p>
            <p>
              <FaPhone />{" "}
              <a href="tel:0659966846" className="contact-link">
                065 996 6846
              </a>
            </p>
            <p>
              <FaMapMarkerAlt /> South Africa, Gauteng and Limpopo
            </p>
            <div className="social-icons">
              <a href="https://www.tiktok.com/@zhufuangency" target="_blank" rel="noopener noreferrer">
                <FaTiktok />
              </a>
              <a href="https://www.instagram.com/zhufuagency" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
              <a href="https://www.facebook.com/zhufuagency" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Enter your name:</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} />
            </div>

            <div className="form-group">
              <label htmlFor="email">Enter your email:</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} />
            </div>

            <div className="form-group">
              <label htmlFor="message">Send a message:</label>
              <textarea id="message" name="message" value={formData.message} onChange={handleChange}></textarea>
            </div>

            <button type="submit">Submit</button>
          </form>
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default Contact;
